import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';
import tokenHeader from '../token-header';

const API_URL = baseUrl()+"/api/all/";

const putDataPenerimaWaiver = 'data-weiver/';
const postDataPenerimaWaiver = 'data-weiver';
const getDataPenerimaWeiver = 'data-weiver';
const deleteDataPenerimaWeiver = 'data-weiver/';
const getDetailPenerimaWeiver = 'data-weiver/';
const importDataWeiver = 'import-weiver';
const putStatusPengajuanWaiver = 'data-weiver/';

class WaiverService {

    deleteDataPenerimaWeiver(id_penerima) {
        return axios.delete(
            API_URL + deleteDataPenerimaWeiver + id_penerima,
            {
                headers: authHeader()
            }
        )
    }

    getDataWaiver(currentPage, pageSize, filter, id_waiver) {
        return axios.get(
            API_URL + getDataPenerimaWeiver + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&id_waiver=' + id_waiver,
            {
                headers: authHeader()
            }
        )
    }   

    getDetailPenerimaWeiver(id_waiver) {
        return axios.get(API_URL + getDetailPenerimaWeiver + id_waiver, {
            headers: authHeader()
        });
    }

    putDataPenerimaWaiver(formdata) {
        return axios.put(API_URL + putDataPenerimaWaiver + formdata.idWaiver, formdata, {
            headers: authHeader()
        });
    }    

    importDataWeiver(idWaiver, file) {
        const form = new FormData();
        form.append('file', file);
        return axios.post(API_URL + importDataWeiver + '?idWaiver=' + idWaiver, form, {
            headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
        });
    }

    putStatusPengajuanWaiver(formdata) {
        const form = new FormData();
        form.append('file', formdata.file);
        return axios.put(API_URL + putStatusPengajuanWaiver + formdata.id_dat_waiver, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': tokenHeader()
            }
        });
    }

    postDataPenerimaWaiver(formdata) {
        return axios.post(API_URL + postDataPenerimaWaiver, formdata, {
            headers: {
                'Authorization': tokenHeader()
            }
        });
    }
}


export default new WaiverService();